import { render, staticRenderFns } from "./XSearch.vue?vue&type=template&id=79e4a28c&scoped=true"
import script from "./XSearch.vue?vue&type=script&lang=ts"
export * from "./XSearch.vue?vue&type=script&lang=ts"
import style0 from "./XSearch.vue?vue&type=style&index=0&id=79e4a28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4a28c",
  null
  
)

export default component.exports